export default "__VITE_ASSET__C4N$MXbR__"